import { cn } from "@tellescope/ui";
import { useTwilioPhoneNumbers } from "./useTwilioPhoneNumbers";
import { TwilioLoadingState } from "./TwilioLoadingState";
import { AwaitingConfirmation } from "./AwaitingConfirmation";
import { VerifyTollFreeNumberView } from "./VerifyTollFreeNumberView";
import { BuyTollFreeNumbersView } from "./BuyTollFreeNumbersView";
import { YourPhoneNumbersView } from "./YourPhoneNumbersView";
import { BuyFirstNumberPrompt } from "./BuyFirstNumberPrompt";

export interface TwilioPhoneNumbersProps {
  className?: string;
}

export const TwilioPhoneNumbers = ({ className }: TwilioPhoneNumbersProps) => {
  const {
    isAdmin,
    areaCodeQuery,
    setAreaCodeQuery,
    digitsQuery,
    setDigitsQuery,
    isBuying,
    setIsBuying,
    searchTFNQuery,
    searchedNumbers,
    isSearching,
    purchasedNumbers,
    cannotBuy,
    isLoading,
    actionsIsLoading,
    buyTFN,
    isPurchasing,
    verifyingNumber,
    startVerification,
    closeVerification,
    verificationEmbedUrl,
    isLoadingEmbed,
    embedError,
  } = useTwilioPhoneNumbers();

  return (
    <div className={cn("flex flex-col min-h-0 h-full", className)}>
      {actionsIsLoading ? (
        <TwilioLoadingState />
      ) : cannotBuy ? (
        <AwaitingConfirmation />
      ) : verifyingNumber ? (
        <VerifyTollFreeNumberView
          phoneNumber={verifyingNumber.phoneNumber}
          embedUrl={verificationEmbedUrl}
          isLoadingEmbed={isLoadingEmbed}
          hasError={embedError}
          onClose={closeVerification}
        />
      ) : isBuying ? (
        <BuyTollFreeNumbersView
          isAdmin={isAdmin}
          areaCodeQuery={areaCodeQuery}
          setAreaCodeQuery={setAreaCodeQuery}
          digitsQuery={digitsQuery}
          setDigitsQuery={setDigitsQuery}
          searchedNumbers={searchedNumbers}
          isSearching={isSearching}
          hasSearchError={searchTFNQuery.isError}
          isPurchasing={isPurchasing}
          onBuy={(phoneNumber) => buyTFN({ phoneNumber }, { onSuccess: () => setIsBuying(false) })}
          onBack={() => setIsBuying(false)}
        />
      ) : purchasedNumbers.length ? (
        <YourPhoneNumbersView
          isAdmin={isAdmin}
          isLoading={isLoading}
          purchasedNumbers={purchasedNumbers}
          onStartVerification={startVerification}
          onBuyAnother={() => setIsBuying(true)}
        />
      ) : (
        <BuyFirstNumberPrompt onBuy={() => setIsBuying(true)} />
      )}
    </div>
  );
};
